module.exports = __webpack_public_path__ + "static/media/sample_03.df49ccb8.png";